c<!--
  sgnInpNdMainMttCnf.vue ( 6 step, mblElcSgn03, mblElcSgn04 )
  - 서명입력 및 주요사항확인
 -->
<template>
  <div id="wrap" class="wrap_layout">
    <Header
      :rtrnAnimInsYn="state.rtrnAnimInsYn"
      type="type_point"
      :ernpeDivNm="state.ernpeDivNm"
    />
    <!--Container [s]-->
    <div class="container">
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section">
          <p class="tit mgt0">서명입력 및 주요사항</p>
          <p class="txt02">
            아래 모든 서류를 개별 확인하시고 덧쓰기 및 문서내 서명입력 버튼을
            터치해주세요. 이후 화면하단의 입력완료 버튼을 누르시면 다음 단계로
            이동이 가능합니다.
          </p>
          <ul class="point_check_list">
            <Accordion
              :ref="(el) => (sbcpDocRefLs[idx] = el)"
              :idx="idx"
              v-for="(vo, idx) in state.opmtLst"
              :key="idx"
              :vo="vo"
              @openDoc="openDoc(idx)"
              @docCreated="docCreated(vo.ctnsKdCd)"
              @sgnSucceed="getLabelProc()"
              :pdIntAgr="pdIntAgr"
            >
              <template v-if="vo.isOverWrite">
                <AddInp
                  :contents="vo.overWriteData"
                  :ctnsKdCd="vo.ctnsKdCd"
                  :ref="(inpEl) => (addInpRefLs[vo.ctnsKdCd] = inpEl)"
                  @allKeyPadFinished="allKeyPadFinished()"
                />
                <div class="btn_area mgt10">
                  <button
                    type="button"
                    class="btn_main small"
                    @click="docCnf(idx, vo.ctnsKdCd, true)"
                  >
                    <span>서류확인</span>
                  </button>
                </div>
              </template>
              <template
                v-else-if="vo.ctnsKdCd == '100740' || vo.ctnsKdCd == '100741'"
              >
                <p class="tip_area">
                  본 동의는 보험계약 체결에 필수적이지 않으며 동의를 거부하실 수
                  있습니다.
                </p>
                <div class="check_agree_box" v-show="false">
                  <span class="radio_box">
                    <input
                      type="radio"
                      id="option01_100740"
                      name="radioOption_100740"
                      value="2"
                      v-model="pdIntAgr.allPdIntAgrYn"
                      @change="allSetAgr('pdIntAgr', $event.target.value)"
                    />
                    <label for="option01_100740">전체미동의</label>
                  </span>
                  <span class="radio_box">
                    <input
                      type="radio"
                      id="option02_100740"
                      name="radioOption_100740"
                      value="1"
                      v-model="pdIntAgr.allPdIntAgrYn"
                      @change="allSetAgr('pdIntAgr', $event.target.value)"
                    />
                    <label for="option02_100740">전체동의</label>
                  </span>
                </div>
                <div class="unit">
                  <strong class="tit_unit">① 수집·이용에 관한 사항</strong>
                  <p class="txt_unit">개인신용정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree01_100740"
                        name="agreeOption_100740"
                        value="2"
                        v-model="pdIntAgr.indvInfUseAgrYn"
                        @change="setAgr('pdIntAgr', $event.target.value)"
                      />
                      <label for="agree01_100740">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree01_1_100740"
                        name="agreeOption_100740"
                        value="1"
                        v-model="pdIntAgr.indvInfUseAgrYn"
                        @change="setAgr('pdIntAgr', $event.target.value)"
                      />
                      <label for="agree01_1_100740">동의함</label>
                    </span>
                  </div>
                  <p class="txt_unit">
                    전자적 전송매체를 통한 광고성 정보의 수신을
                    동의하시겠습니까?<br />
                    * 전송매체 : 전체(문자, 이메일 , 전화(ARS), DM)
                  </p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree02_100740"
                        name="agreeOption2_100740"
                        value="2"
                        v-model="pdIntAgr.advtLnmInfRciAgrYn"
                        @change="setAgr('pdIntAgr', $event.target.value)"
                      />
                      <label for="agree02_100740">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree02_1_100740"
                        name="agreeOption2_100740"
                        value="1"
                        v-model="pdIntAgr.advtLnmInfRciAgrYn"
                        @change="setAgr('pdIntAgr', $event.target.value)"
                      />
                      <label for="agree02_1_100740">동의함</label>
                    </span>
                  </div>
                </div>
                <div class="unit">
                  <strong class="tit_unit">② 제공에 관한 사항</strong>
                  <p class="txt_unit">개인신용정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree03_100740"
                        name="agreeOption3_100740"
                        value="2"
                        v-model="pdIntAgr.indvInfInqAgrYn"
                        @change="setAgr('pdIntAgr1', $event.target.value)"
                      />
                      <label for="agree03_100740">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree03_1_100740"
                        name="agreeOption3_100740"
                        value="1"
                        v-model="pdIntAgr.indvInfInqAgrYn"
                        @change="setAgr('pdIntAgr1', $event.target.value)"
                      />
                      <label for="agree03_1_100740">동의함</label>
                    </span>
                  </div>
                </div>
                <div class="btn_area mgt20">
                  <button
                    type="button"
                    class="btn_main small"
                    @click="docCnf(idx, vo.ctnsKdCd)"
                  >
                    <span>서류확인</span>
                  </button>
                </div>
              </template>
              <template
                v-else-if="vo.ctnsKdCd == '100738' || vo.ctnsKdCd == '100739'"
              >
                <p class="tip_area">
                  본 동의는 '보험계약 인수심사·체결·이행·유지·관리'를 위해
                  필수적인 사항으로 동의를 거부하시는 경우 관련 업무수행이
                  불가능 합니다.
                </p>
                <div class="check_agree_box">
                  <span class="radio_box">
                    <input
                      type="radio"
                      id="option01_100738"
                      name="radioOption_100738"
                      value="2"
                      v-model="ctrCcluAgr.allCtrCcluAgrYn"
                      @change="allSetAgr('ctrCcluAgr', $event.target.value)"
                    />
                    <label for="option01_100738">전체미동의</label>
                  </span>
                  <span class="radio_box">
                    <input
                      type="radio"
                      id="option02_100738"
                      name="radioOption_100738"
                      value="1"
                      v-model="ctrCcluAgr.allCtrCcluAgrYn"
                      @change="allSetAgr('ctrCcluAgr', $event.target.value)"
                    />
                    <label for="option02_100738">전체동의</label>
                  </span>
                </div>
                <div class="unit">
                  <strong class="tit_unit">① 수집·이용에 관한 사항</strong>
                  <p class="txt_unit">고유식별정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree01_100738"
                        name="agreeOption_100738"
                        value="2"
                        v-model="ctrCcluAgr.indvInfUseAgrYn"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree01_100738">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree01_1_100738"
                        name="agreeOption_100738"
                        value="1"
                        v-model="ctrCcluAgr.indvInfUseAgrYn"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree01_1_100738">동의함</label>
                    </span>
                  </div>
                  <p class="txt_unit">민감정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree02_100738"
                        name="agreeOption2_100738"
                        value="2"
                        v-model="ctrCcluAgr.indvInfUseAgrYn2"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree02_100738">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree02_1_100738"
                        name="agreeOption2_100738"
                        value="1"
                        v-model="ctrCcluAgr.indvInfUseAgrYn2"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree02_1_100738">동의함</label>
                    </span>
                  </div>
                  <p class="txt_unit">개인신용정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree03_100738"
                        name="agreeOption3_100738"
                        value="2"
                        v-model="ctrCcluAgr.indvInfUseAgrYn3"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree03_100738">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree03_1_100738"
                        name="agreeOption3_100738"
                        value="1"
                        v-model="ctrCcluAgr.indvInfUseAgrYn3"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree03_1_100738">동의함</label>
                    </span>
                  </div>
                </div>
                <div class="unit">
                  <strong class="tit_unit">② 제공에 관한 사항</strong>
                  <p class="txt_unit">고유식별정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree2_100738"
                        name="agreeOption_2_100738"
                        value="2"
                        v-model="ctrCcluAgr.indvInfOfrAgrYn"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree2_100738">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree2_1_100738"
                        name="agreeOption_2_100738"
                        value="1"
                        v-model="ctrCcluAgr.indvInfOfrAgrYn"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree2_1_100738">동의함</label>
                    </span>
                  </div>
                  <p class="txt_unit">민감정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree2_2_100738"
                        name="agreeOption_21_100738"
                        value="2"
                        v-model="ctrCcluAgr.indvInfOfrAgrYn2"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree2_2_100738">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree2_3_100738"
                        name="agreeOption_21_100738"
                        value="1"
                        v-model="ctrCcluAgr.indvInfOfrAgrYn2"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree2_3_100738">동의함</label>
                    </span>
                  </div>
                  <p class="txt_unit">개인신용정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree2_4_100738"
                        name="agreeOption_22_100738"
                        value="2"
                        v-model="ctrCcluAgr.indvInfOfrAgrYn3"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree2_4_100738">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree2_5_100738"
                        name="agreeOption_22_100738"
                        value="1"
                        v-model="ctrCcluAgr.indvInfOfrAgrYn3"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree2_5_100738">동의함</label>
                    </span>
                  </div>
                </div>
                <div class="unit">
                  <strong class="tit_unit">③ 조회에 관한 사항</strong>
                  <p class="txt_unit">고유식별정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree3_100738"
                        name="agreeOption_3_100738"
                        value="2"
                        v-model="ctrCcluAgr.indvInfInqAgrYn"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree3_100738">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree3_1_100738"
                        name="agreeOption_3_100738"
                        value="1"
                        v-model="ctrCcluAgr.indvInfInqAgrYn"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree3_1_100738">동의함</label>
                    </span>
                  </div>
                  <p class="txt_unit">민감정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree3_2_100738"
                        name="agreeOption_32_100738"
                        value="2"
                        v-model="ctrCcluAgr.indvInfInqAgrYn2"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree3_2_100738">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree3_3_100738"
                        name="agreeOption_32_100738"
                        value="1"
                        v-model="ctrCcluAgr.indvInfInqAgrYn2"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree3_3_100738">동의함</label>
                    </span>
                  </div>
                  <p class="txt_unit">개인신용정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree3_4_100738"
                        name="agreeOption_33_100738"
                        value="2"
                        v-model="ctrCcluAgr.indvInfInqAgrYn3"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree3_4_100738">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree3_5_100738"
                        name="agreeOption_33_100738"
                        value="1"
                        v-model="ctrCcluAgr.indvInfInqAgrYn3"
                        @change="setAgr('ctrCcluAgr')"
                      />
                      <label for="agree3_5_100738">동의함</label>
                    </span>
                  </div>
                </div>
                <div class="btn_area mgt20">
                  <button
                    type="button"
                    class="btn_main small"
                    @click="docCnf(idx, vo.ctnsKdCd, false)"
                  >
                    <span>서류확인</span>
                  </button>
                </div>
              </template>
              <template v-else-if="vo.ctnsKdCd == '100735'">
                <p class="tip_area">
                  본 동의는 '보험업무처리(상담 체결 유지 관리), 보험료·보험금
                  송금을 위해 필수적인 사항이므로 동의를 거부하시는 경우 관련
                  서비스가 일부 제한될 수 있습니다.
                </p>
                <div class="check_agree_box">
                  <span class="radio_box">
                    <input
                      type="radio"
                      id="option01_100735"
                      name="radioOption_100735"
                      value="2"
                      v-model="th3peInsAgr.allTh3peAgrYn"
                      @change="allSetAgr('th3peAgr', $event.target.value)"
                    />
                    <label for="option01_100735">전체미동의</label>
                  </span>
                  <span class="radio_box">
                    <input
                      type="radio"
                      id="option02_100735"
                      name="radioOption_100735"
                      value="1"
                      v-model="th3peInsAgr.allTh3peAgrYn"
                      @change="allSetAgr('th3peAgr', $event.target.value)"
                    />
                    <label for="option02_100735">전체동의</label>
                  </span>
                </div>
                <div class="unit">
                  <strong class="tit_unit">① 수집·이용에 관한 사항</strong>
                  <p class="txt_unit">고유식별정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree01_100735"
                        name="agreeOption_100735"
                        value="2"
                        v-model="th3peInsAgr.th3peIndvInfUseAgrYn"
                        @change="setAgr('th3peAgr')"
                      />
                      <label for="agree01_100735">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree01_1_100735"
                        name="agreeOption_100735"
                        value="1"
                        v-model="th3peInsAgr.th3peIndvInfUseAgrYn"
                        @change="setAgr('th3peAgr')"
                      />
                      <label for="agree01_1_100735">동의함</label>
                    </span>
                  </div>
                  <p class="txt_unit">개인신용정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree02_100735"
                        name="agreeOption2_100735"
                        value="2"
                        v-model="th3peInsAgr.th3peIndvInfUseAgrYn2"
                        @change="setAgr('th3peAgr')"
                      />
                      <label for="agree02_100735">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree02_1_100735"
                        name="agreeOption2_100735"
                        value="1"
                        v-model="th3peInsAgr.th3peIndvInfUseAgrYn2"
                        @change="setAgr('th3peAgr')"
                      />
                      <label for="agree02_1_100735">동의함</label>
                    </span>
                  </div>
                </div>
                <div class="unit">
                  <strong class="tit_unit">② 제공에 관한 사항</strong>
                  <p class="txt_unit">고유식별정보 제공에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree2_100735"
                        name="agreeOption_2_100735"
                        value="2"
                        v-model="th3peInsAgr.th3peIndvInfOfrAgrYn"
                        @change="setAgr('th3peAgr')"
                      />
                      <label for="agree2_100735">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree2_1_100735"
                        name="agreeOption_2_100735"
                        value="1"
                        v-model="th3peInsAgr.th3peIndvInfOfrAgrYn"
                        @change="setAgr('th3peAgr')"
                      />
                      <label for="agree2_1_100735">동의함</label>
                    </span>
                  </div>
                  <p class="txt_unit">개인신용정보 제공에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree2_2_100735"
                        name="agreeOption_21_100735"
                        value="2"
                        v-model="th3peInsAgr.th3peIndvInfOfrAgrYn2"
                        @change="setAgr('th3peAgr')"
                      />
                      <label for="agree2_2_100735">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree2_3_100735"
                        name="agreeOption_21_100735"
                        value="1"
                        v-model="th3peInsAgr.th3peIndvInfOfrAgrYn2"
                        @change="setAgr('th3peAgr')"
                      />
                      <label for="agree2_3_100735">동의함</label>
                    </span>
                  </div>
                </div>
                <div class="unit">
                  <strong class="tit_unit">③ 조회에 관한 사항</strong>
                  <p class="txt_unit">고유식별정보 조회에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree3_100735"
                        name="agreeOption_3_100735"
                        value="2"
                        v-model="th3peInsAgr.th3peIndvInfInqAgrYn"
                        @change="setAgr('th3peAgr')"
                      />
                      <label for="agree3_100735">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree3_1_100735"
                        name="agreeOption_3_100735"
                        value="1"
                        v-model="th3peInsAgr.th3peIndvInfInqAgrYn"
                        @change="setAgr('th3peAgr')"
                      />
                      <label for="agree3_1_100735">동의함</label>
                    </span>
                  </div>
                  <p class="txt_unit">개인신용정보 조회에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree3_2_100735"
                        name="agreeOption_32_100735"
                        value="2"
                        v-model="th3peInsAgr.th3peIndvInfInqAgrYn2"
                        @change="setAgr('th3peAgr')"
                      />
                      <label for="agree3_2_100735">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree3_3_100735"
                        name="agreeOption_32_100735"
                        value="1"
                        v-model="th3peInsAgr.th3peIndvInfInqAgrYn2"
                        @change="setAgr('th3peAgr')"
                      />
                      <label for="agree3_3_100735">동의함</label>
                    </span>
                  </div>
                </div>
                <div class="btn_area mgt20">
                  <button
                    type="button"
                    class="btn_main small"
                    @click="docCnf(idx, vo.ctnsKdCd, false)"
                  >
                    <span>서류확인</span>
                  </button>
                </div>
              </template>
              <template v-else-if="vo.ctnsKdCd == '120638'">
                <p class="tip_area">
                  본 동의는 '보험계약 인수심사·체결·이행·유지·관리'를 위해
                  필수적인 사항으로 동의를 거부하시는 경우 관련 업무수행이
                  불가능 합니다.
                </p>
                <div class="check_agree_box">
                  <span class="radio_box">
                    <input
                      type="radio"
                      id="option01_120638"
                      name="radioOption_120638"
                      value="2"
                      v-model="bioCcluAgr.allBioCcluAgrYn"
                      @change="allSetAgr('bioCcluAgr', $event.target.value)"
                    />
                    <label for="option01_120638">전체미동의</label>
                  </span>
                  <span class="radio_box">
                    <input
                      type="radio"
                      id="option02_120638"
                      name="radioOption_120638"
                      value="1"
                      v-model="bioCcluAgr.allBioCcluAgrYn"
                      @change="allSetAgr('bioCcluAgr', $event.target.value)"
                    />
                    <label for="option02_120638">전체동의</label>
                  </span>
                </div>
                <div class="unit">
                  <strong class="tit_unit">① 수집·이용에 관한 사항</strong>
                  <p class="txt_unit">고유식별정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree01_120638"
                        name="agreeOption_120638"
                        value="2"
                        v-model="bioCcluAgr.indvInfUseAgrYn"
                        @change="setAgr('bioCcluAgr')"
                      />
                      <label for="agree01_120638">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree01_1_120638"
                        name="agreeOption_120638"
                        value="1"
                        v-model="bioCcluAgr.indvInfUseAgrYn"
                        @change="setAgr('bioCcluAgr')"
                      />
                      <label for="agree01_1_120638">동의함</label>
                    </span>
                  </div>
                  <p class="txt_unit">민감정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree02_120638"
                        name="agreeOption2_120638"
                        value="2"
                        v-model="bioCcluAgr.indvInfUseAgrYn2"
                        @change="setAgr('bioCcluAgr')"
                      />
                      <label for="agree02_120638">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree02_1_120638"
                        name="agreeOption2_120638"
                        value="1"
                        v-model="bioCcluAgr.indvInfUseAgrYn2"
                        @change="setAgr('bioCcluAgr')"
                      />
                      <label for="agree02_1_120638">동의함</label>
                    </span>
                  </div>
                </div>
                <div class="unit">
                  <strong class="tit_unit">② 제공에 관한 사항</strong>
                  <p class="txt_unit">고유식별정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree2_120638"
                        name="agreeOption_2_120638"
                        value="2"
                        v-model="bioCcluAgr.indvInfOfrAgrYn"
                        @change="setAgr('bioCcluAgr')"
                      />
                      <label for="agree2_120638">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree2_1_120638"
                        name="agreeOption_2_120638"
                        value="1"
                        v-model="bioCcluAgr.indvInfOfrAgrYn"
                        @change="setAgr('bioCcluAgr')"
                      />
                      <label for="agree2_1_120638">동의함</label>
                    </span>
                  </div>
                  <p class="txt_unit">민감정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree2_2_120638"
                        name="agreeOption_21_120638"
                        value="2"
                        v-model="bioCcluAgr.indvInfOfrAgrYn2"
                        @change="setAgr('bioCcluAgr')"
                      />
                      <label for="agree2_2_120638">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree2_3_120638"
                        name="agreeOption_21_120638"
                        value="1"
                        v-model="bioCcluAgr.indvInfOfrAgrYn2"
                        @change="setAgr('bioCcluAgr')"
                      />
                      <label for="agree2_3_120638">동의함</label>
                    </span>
                  </div>
                </div>
                <div class="unit">
                  <strong class="tit_unit">③ 조회에 관한 사항</strong>
                  <p class="txt_unit">고유식별정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree3_120638"
                        name="agreeOption_3_120638"
                        value="2"
                        v-model="bioCcluAgr.indvInfInqAgrYn"
                        @change="setAgr('bioCcluAgr')"
                      />
                      <label for="agree3_120638">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree3_1_120638"
                        name="agreeOption_3_120638"
                        value="1"
                        v-model="bioCcluAgr.indvInfInqAgrYn"
                        @change="setAgr('bioCcluAgr')"
                      />
                      <label for="agree3_1_120638">동의함</label>
                    </span>
                  </div>
                  <p class="txt_unit">민감정보 수집·이용에 동의하십니까?</p>
                  <div class="opinion_check">
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree3_2_120638"
                        name="agreeOption_32_120638"
                        value="2"
                        v-model="bioCcluAgr.indvInfInqAgrYn2"
                        @change="setAgr('bioCcluAgr')"
                      />
                      <label for="agree3_2_120638">동의하지않음</label>
                    </span>
                    <span class="radio_box">
                      <input
                        type="radio"
                        id="agree3_3_120638"
                        name="agreeOption_32_120638"
                        value="1"
                        v-model="bioCcluAgr.indvInfInqAgrYn2"
                        @change="setAgr('bioCcluAgr')"
                      />
                      <label for="agree3_3_120638">동의함</label>
                    </span>
                  </div>
                </div>
                <div class="btn_area mgt20">
                  <button
                    type="button"
                    class="btn_main small"
                    @click="docCnf(idx, vo.ctnsKdCd, false)"
                  >
                    <span>서류확인</span>
                  </button>
                </div>
              </template>
              <template v-else-if="vo.ctnsKdCd == '116314'">
                <p class="tit_tbl">대면정보 확인</p>
                <div class="data_table type_row data">
                  <table>
                    <caption class="blind">
                      대면정보 확인
                    </caption>
                    <colgroup>
                      <col style="width: 78px" />
                      <col />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row">설명방법</th>
                        <td>{{ state.cfntDscMd }}</td>
                      </tr>
                      <tr>
                        <th scope="row">대면일시</th>
                        <td>{{ state.cfntDtm }}</td>
                      </tr>
                      <tr>
                        <th scope="row">대면장소</th>
                        <td>{{ state.cfntDscPlc }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p class="tip_area">
                  영업담당자가 직접 입력한 내용이며, 사실과 다른 경우 전자서명
                  진행을 중단하시기 바랍니다.
                </p>
                <div class="btn_area mgt20">
                  <button
                    type="button"
                    class="btn_main small"
                    @click="docCnf(idx, vo.ctnsKdCd, false)"
                  >
                    <span>서류확인</span>
                  </button>
                </div>
              </template>
            </Accordion>
          </ul>
          <ul class="download_list">
            <li>
              <button type="button" class="btn_doc" @click="sbcpDocDwld">
                <span>청약서류<br />다운로드</span>
              </button>
            </li>
            <li>
              <button type="button" class="btn_agree" @click="insClusDwld">
                <span>보험약관<br />다운로드</span>
              </button>
            </li>
          </ul>
          <p class="txt02">※ 청약서류 문서암호 : 생년월일 6자리</p>
          <p class="txt02">
            ※ 완료된 전자서명은 메리츠화재 전산으로 전송되며 담당자 확인 후
            수납처리가 진행됩니다. 즉시이체를 선택한 경우, 서명 완료시 1회
            보험료 출금과 수납이 진행됩니다.
          </p>
          <div class="btn_area col2 masterBtn">
            <button type="button" class="btn_main type3" @click="goPrevPage">
              <span>이전</span>
            </button>
            <button type="button" class="btn_main" @click="goNextPage">
              <span>{{ masterButton.label }}</span>
            </button>
          </div>
        </div>
      </div>
      <iframe
        id="downloadFrame"
        ref="downloadFrame"
        style="width: 0px; height: 0px"
        src=""
      ></iframe>
      <div class="pop_wrap" :class="state.makeSbcpDoc ? 'active' : ''">
        <div class="dimm"></div>
        <div class="pop_content pop_agree">
          <section class="wrap_pop">
            <div class="popbox_wrap">
              <div class="popbox_cont type2">
                <p class="txt_ongoing">
                  <strong
                    >부본 생성중입니다. <br />
                    잠시만 기다려주시기 바랍니다</strong
                  >
                </p>
                <div class="caution_wrap">
                  <p class="tit">주의사항</p>
                  <p class="txt03">
                    팝업이 종료되기 까지 <span class="point">기다려주세요.</span
                    ><br /><span class="point"
                      >화면 강제로 종료시 전자서명 진행에 영향</span
                    >을 줄 수 있습니다.
                  </p>
                  <p class="txt03">
                    정상 완료 시 자동으로 팝업 종료 및 청약서부본 다운로드를
                    시작합니다.
                  </p>
                  <p class="txt03">
                    <span class="point"
                      >화면이 멈추거나 문의사항이 있는 경우</span
                    >는 영업담당자에게 확인을 요청 하시기 바랍니다.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import useDialog from "@/common/dialog";
import Header from "@/components/common/Header.vue";
import Accordion from "@/components/common/Accordion.vue";
import AddInp from "@/components/common/AddInp.vue";
import { flickingLayout, enableScroll } from "@/common/scrnCtrl";
import { isIOS } from "mobile-device-detect";
export default {
  name: "sgnInpNdMainMttCnf",
  components: {
    Header,
    Accordion,
    AddInp,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const axios = inject("axios");
    const dialog = useDialog();
    const downloadFrame = ref(null);

    enableScroll();

    onMounted(async () => {
      await load();

      util.saveLog("009", "서명입력및주요사항확인"); // 009 : 화면진입
      if (sessionUserInfo == null) {
        router.push({ name: "sessionExpired" });
        return;
      }

      //반려동물 보험 여부
      if (
        sessionUserInfo.ctrBasInfCoVo[0].rpsPdCd == "61139" ||
        sessionUserInfo.ctrBasInfCoVo[0].rpsPdCd == "61238" ||
        sessionUserInfo.ctrBasInfCoVo[0].rpsPdCd == "61239"
      ) {
        state.rtrnAnimInsYn = true;
      } else {
        state.rtrnAnimInsYn = false;
      }

      state.ernpeDivNm = sessionUserInfo.ernpeDivNm;

      state.maInspeNm = sessionUserInfo.ctrBasInfCoVo[0].maInspeNm;

      let ctrCovCoVo = _.filter(sessionUserInfo.ctrCovCoVoLst, function (info) {
        return info.covCd == "660033" || info.covCd == "660059";
      });

      if (ctrCovCoVo.length > 0) {
        fireCmpsRpsbIns.gurtNm = ctrCovCoVo[0].pdCovKorFrmuNm;
      }

      variables.cusNoList = sessionUserInfo.cusNoList2;
      variables.polhdRelLst = sessionUserInfo.polhdRelLst;

      if (variables.polhdRelLst.length == 0) {
        variables.polhdRelLst = [
          { efctVal: "01", efctValNm: "본인", idfNo: "" },
        ];
      }

      state.pidfPdYn = sessionUserInfo.pidfPdYn;
      state.piSmns = sessionUserInfo.piSmns;
      state.inspeCnt = sessionUserInfo.inspeCnt;

      fireCmpsRpsbIns.gnrDmgPrem = util.addCommas(
        sessionUserInfo.fireCmpsRpsbGnrPrem + ""
      );
      fireCmpsRpsbIns.lgtmDmgPrem = util.addCommas(
        sessionUserInfo.ctrBasInfCoVo[0].slzPrem + ""
      );

      state.cfntDtm = sessionUserInfo.inspeCfntDtm;
      state.cfntDscMd = store.state.elcSgnInf.cfntInf.inspeCfntDscMd;
      state.cfntDscPlc = store.state.elcSgnInf.cfntInf.inspeCfntDscPlc;
      retrieveMblElcSgnWrdAndOpmtIntz();
      retrieveMblClus();
    });

    onBeforeUpdate(() => {
      sbcpDocRefLs.value = [];
      addInpRefLs.value = {};
    });

    const variables = {
      polhdRelLst: [],
      cusNoList: [],
    };

    const state = reactive({
      currDate: util.formatDate(new Date(), "yyyymmdd"),
      rtrnAnimInsYn: false,
      opmtLst: [],
      crsListFlag: false, // CRS 존재여부
      /////////////////////////////////////
      // premTrsPopupActvnYn: false, // 2회차 이후 보험료 팝업 노출 여부
      cllpeAgr: "", // 모집종사자 설명 동의 여부
      maInspeNm: "", // 피보험자 자녀명
      // 친권자 관련
      papeAgrYn: "", // 친권자 동의여부
      pidfPdYn: "",
      piSmns: "",
      inspeCnt: "",
      ernpeDivNm: "",
      cfntDscMd: "",
      cfntDtm: "",
      cfntDscPlc: "",
      isCnfSbcpDocDwld: false,
      isInsClusDwld: false,
      makeSbcpDoc: false,
    });

    // 계약체결 이행 개인정보 동의 값
    const ctrCcluAgr = reactive({
      allCtrCcluAgrYn: "",
      indvInfUseAgrYn: "", // 개인정보 수집이용동의
      indvInfUseAgrYn2: "", // 개인정보 수집이용동의
      indvInfUseAgrYn3: "", // 개인정보 수집이용동의
      indvInfOfrAgrYn: "", // 개인정보 제공동의
      indvInfOfrAgrYn2: "", // 개인정보 제공동의
      indvInfOfrAgrYn3: "", // 개인정보 제공동의
      indvInfInqAgrYn: "", // 개인정보 조회동의
      indvInfInqAgrYn2: "", // 개인정보 조회동의
      indvInfInqAgrYn3: "", // 개인정보 조회동의
    });

    // 상품소개 동의 개인정보 동의 값
    const pdIntAgr = reactive({
      allPdIntAgrYn: "2",
      indvInfUseAgrYn: "2", // 개인정보 수집 이용 동의 여부
      indvInfInqAgrYn: "2", // 개인정보 제공 이용 동의 여부
      advtLnmInfRciAgrYn: "2", // 전자적 전송매체 광고성 정보 수신 동의 여부
    });

    // 실손의료비 동의체크 값 (ctnsKdCd == 115426)
    const pmmiMedInsAgr = reactive({
      premPyMtt: "", // 보험료 납입에 관한 사항
      gurtLmMtt: "", // 보장 한도에 관한 사항
      ownBrdAmtMtt: "", // 자기부담금에 관한 사항
      gurtRngMtt: "", // 보장범위에 관한 사항
      mltdInsComsWyMtt: "", // 다수보험시 보상방식에 관한 사항
      insPrdRnwlMtt: "", // 보험기간 및 갱신에 관한 사항
      indvInfAgrMtt: "", // 개인정보 동의에 관한 사항
    });

    // 화재배상책임보험 안내사항 (ctnsKdCd == 100887)
    const fireCmpsRpsbIns = reactive({
      gurtNm: "", // 보장명
      gnrDmgPrem: "", // 일반손해보험료
      lgtmDmgPrem: "", // 장기손해보험료
    });

    // 제3자동의
    const th3peInsAgr = reactive({
      allTh3peAgrYn: "",
      th3peIndvInfUseAgrYn: "", // 개인정보 수집이용동의
      th3peIndvInfUseAgrYn2: "", // 개인정보 수집이용동의
      th3peIndvInfOfrAgrYn: "", // 개인정보 제공동의
      th3peIndvInfOfrAgrYn2: "", // 개인정보 제공동의
      th3peIndvInfInqAgrYn: "", // 개인정보 조회동의
      th3peIndvInfInqAgrYn2: "", // 개인정보 조회동의
    });

    const bioCcluAgr = reactive({
      allBioCcluAgrYn: "",
      indvInfUseAgrYn: "", // 개인정보 수집이용동의
      indvInfUseAgrYn2: "", // 개인정보 수집이용동의
      indvInfOfrAgrYn: "", // 개인정보 제공동의
      indvInfOfrAgrYn2: "", // 개인정보 제공동의
      indvInfInqAgrYn: "", // 개인정보 조회동의
      indvInfInqAgrYn2: "", // 개인정보 조회동의
    });

    const sbcpDocRefLs = ref([]);
    const addInpRefLs = ref({});

    const masterButton = reactive({
      label: "영업담당자 확인서",
      status: false,
    });

    var overWriteList = [];

    const docCnf = (idx, ctnsKdCd) => {
      let validAddInpRefLs = true;
      let inpRef = _.find(
        addInpRefLs.value,
        (e) => !util.isNull(e) && e.ctnsKdCd == ctnsKdCd
      );
      if (!util.isNull(inpRef) && !util.isEmpty(inpRef)) {
        _.each(inpRef.parseHtmlList, (inpList, idx) => {
          _.each(inpList.value.keyPadList, (inpList1, idx) => {
            if (inpList1.isAddInp && !inpList1.isFinished) {
              masterButton.label = "주요문구 덧쓰기 입력";
              if (_.isEmpty(inpList1.addInpEl.value)) {
                dialog.alert("덧쓰기가 누락되었습니다.").then(function () {
                  inpList1.addInpEl.focus();
                });
              } else {
                dialog
                  .confirm(
                    `[${inpList1.addInpEl.value}]을 [${inpList1.text}]으로 수정하시겠습니까?`
                  )
                  .then((res) => {
                    if (res == "1") {
                      inpList1.addInpEl.value = inpList1.text;
                      inpRef.completeEvent(inpList, idx);
                    }
                  });
              }
              validAddInpRefLs = false;
              return false;
            }
          });
          if (!validAddInpRefLs) return false;
        });
      }

      if (!validAddInpRefLs) return false;

      if (ctnsKdCd == "100738" || ctnsKdCd == "100739") {
        if (!_.every(ctrCcluAgr, (e) => e == "1")) {
          dialog
            .alert(
              "계약체결.이행을 위한 개인(신용)정보 처리 상세 동의서에 체크하세요."
            )
            .then(() => flickingLayout(option02_100738, true));
          return false;
        }
      } else if (ctnsKdCd == "100735") {
        if (!_.every(th3peInsAgr, (e) => e == "1")) {
          dialog
            .alert(
              "보험업무처리를 위한 개인(신용)정보 수집·이용 필수 동의서(제3자동의)에 체크하세요."
            )
            .then(() => flickingLayout(option01_100735, true));
          return false;
        }
      } else if (ctnsKdCd == "120638") {
        if (!_.every(bioCcluAgr, (e) => e == "1")) {
          dialog
            .alert(
              "바이오(지문)정보 활용 계약체결·이행을 위한 개인(신용)정보 처리 상세 동의서에 체크하세요."
            )
            .then(() => flickingLayout(option02_120638, true));
          return false;
        }
      }

      sbcpDocRefLs.value[idx].docCnf();
    };

    const allSetAgr = (type, v) => {
      switch (type) {
        case "pdIntAgr":
          pdIntAgr.indvInfUseAgrYn = v;
          pdIntAgr.indvInfInqAgrYn = v;
          pdIntAgr.advtLnmInfRciAgrYn = v;

          let pdInt = _.find(
            sbcpDocRefLs.value,
            (d) => d.vo.ctnsKdCd == "100740" || d.vo.ctnsKdCd == "100741"
          );
          pdInt?.clearSgnInpCompYn();
          break;
        case "ctrCcluAgr":
          ctrCcluAgr.indvInfUseAgrYn = v;
          ctrCcluAgr.indvInfUseAgrYn2 = v;
          ctrCcluAgr.indvInfUseAgrYn3 = v;
          ctrCcluAgr.indvInfOfrAgrYn = v;
          ctrCcluAgr.indvInfOfrAgrYn2 = v;
          ctrCcluAgr.indvInfOfrAgrYn3 = v;
          ctrCcluAgr.indvInfInqAgrYn = v;
          ctrCcluAgr.indvInfInqAgrYn2 = v;
          ctrCcluAgr.indvInfInqAgrYn3 = v;
          if (v == 1) {
            masterButton.label = "서류확인";
          } else {
            masterButton.label = "(필수사항) 동의 선택";
          }
          break;
        case "th3peAgr":
          th3peInsAgr.th3peIndvInfUseAgrYn = v;
          th3peInsAgr.th3peIndvInfUseAgrYn2 = v;
          th3peInsAgr.th3peIndvInfOfrAgrYn = v;
          th3peInsAgr.th3peIndvInfOfrAgrYn2 = v;
          th3peInsAgr.th3peIndvInfInqAgrYn = v;
          th3peInsAgr.th3peIndvInfInqAgrYn2 = v;
          if (v == 1) {
            masterButton.label = "서류확인";
          } else {
            masterButton.label = "(필수사항) 동의 선택";
          }
          break;
        case "bioCcluAgr":
          bioCcluAgr.indvInfUseAgrYn = v;
          bioCcluAgr.indvInfUseAgrYn2 = v;
          bioCcluAgr.indvInfOfrAgrYn = v;
          bioCcluAgr.indvInfOfrAgrYn2 = v;
          bioCcluAgr.indvInfInqAgrYn = v;
          bioCcluAgr.indvInfInqAgrYn2 = v;
          if (v == 1) {
            masterButton.label = "서류확인";
          } else {
            masterButton.label = "(필수사항) 동의 선택";
          }
          break;
      }
    };

    const setAgr = (type, v) => {
      switch (type) {
        case "pdIntAgr":
          pdIntAgr.allPdIntAgrYn = v;
          pdIntAgr.advtLnmInfRciAgrYn = v;
          pdIntAgr.indvInfUseAgrYn = v;
          if (v == "2") {
            pdIntAgr.indvInfInqAgrYn = v;
          }
          let pdInt = _.find(
            sbcpDocRefLs.value,
            (d) => d.vo.ctnsKdCd == "100740" || d.vo.ctnsKdCd == "100741"
          );
          pdInt?.clearSgnInpCompYn();
          break;
        case "pdIntAgr1":
          pdIntAgr.allPdIntAgrYn = v;
          pdIntAgr.advtLnmInfRciAgrYn = v;
          pdIntAgr.indvInfUseAgrYn = v;
          pdIntAgr.indvInfInqAgrYn = v;

          let pdInt1 = _.find(
            sbcpDocRefLs.value,
            (d) => d.vo.ctnsKdCd == "100740" || d.vo.ctnsKdCd == "100741"
          );
          pdInt1?.clearSgnInpCompYn();
          break;
        case "ctrCcluAgr":
          if (
            ctrCcluAgr.indvInfUseAgrYn == "1" &&
            ctrCcluAgr.indvInfUseAgrYn2 == "1" &&
            ctrCcluAgr.indvInfUseAgrYn3 == "1" &&
            ctrCcluAgr.indvInfOfrAgrYn == "1" &&
            ctrCcluAgr.indvInfOfrAgrYn2 == "1" &&
            ctrCcluAgr.indvInfOfrAgrYn3 == "1" &&
            ctrCcluAgr.indvInfInqAgrYn == "1" &&
            ctrCcluAgr.indvInfInqAgrYn2 == "1" &&
            ctrCcluAgr.indvInfInqAgrYn3 == "1"
          ) {
            ctrCcluAgr.allCtrCcluAgrYn = "1";
            masterButton.label = "서류확인";
          } else {
            ctrCcluAgr.allCtrCcluAgrYn = "2";
            masterButton.label = "(필수사항) 동의 선택";
          }
          break;
        case "th3peAgr":
          if (
            th3peInsAgr.th3peIndvInfUseAgrYn == "1" &&
            th3peInsAgr.th3peIndvInfUseAgrYn2 == "1" &&
            th3peInsAgr.th3peIndvInfOfrAgrYn == "1" &&
            th3peInsAgr.th3peIndvInfOfrAgrYn2 == "1" &&
            th3peInsAgr.th3peIndvInfInqAgrYn == "1" &&
            th3peInsAgr.th3peIndvInfInqAgrYn2 == "1"
          ) {
            th3peInsAgr.allTh3peAgrYn = "1";
            masterButton.label = "서류확인";
          } else {
            th3peInsAgr.allTh3peAgrYn = "2";
            masterButton.label = "(필수사항) 동의 선택";
          }
          break;
        case "bioCcluAgr":
          if (
            bioCcluAgr.indvInfUseAgrYn == "1" &&
            bioCcluAgr.indvInfUseAgrYn2 == "1" &&
            bioCcluAgr.indvInfOfrAgrYn == "1" &&
            bioCcluAgr.indvInfOfrAgrYn2 == "1" &&
            bioCcluAgr.indvInfInqAgrYn == "1" &&
            bioCcluAgr.indvInfInqAgrYn2 == "1"
          ) {
            bioCcluAgr.allBioCcluAgrYn = "1";
            masterButton.label = "서류확인";
          } else {
            bioCcluAgr.allBioCcluAgrYn = "2";
            masterButton.label = "(필수사항) 동의 선택";
          }
          break;
      }
    };

    const openDoc = (idx) => {
      _.each(sbcpDocRefLs.value, (v, i) => {
        if (i == idx) {
          if (!v.isSlotEmpty) {
            getLabelProc();
          }
          return;
        } else {
          v.expanded = false;
        }
      });
    };

    const docCreated = (ctnsKdCd) => {
      let inpRef = _.find(
        addInpRefLs.value,
        (e) => !util.isNull(e) && e.ctnsKdCd == ctnsKdCd
      );

      if (!util.isNull(inpRef) && !util.isEmpty(inpRef)) {
        let returnFlag = true;
        _.each(inpRef.parseHtmlList, (inpList, idx) => {
          _.each(inpList.value.keyPadList, (inpList1) => {
            if (inpList1.isAddInp && !inpList1.isFinished) {
              inpList1.addInpEl.focus();
              masterButton.label = "주요문구 덧쓰기 입력";
              returnFlag = false;
              return false;
            }
          });
          if (!returnFlag) return false;
        });
      }

      if (
        ctnsKdCd == "100738" ||
        ctnsKdCd == "100739" ||
        ctnsKdCd == "120638" ||
        ctnsKdCd == "100735"
      ) {
        masterButton.label = "(필수사항) 동의 선택";
      }
    };

    const goPrevPage = () => {
      router.go(-1);
    };

    const goNextPage = async () => {
      let validSbcpDocRefLs = true;

      let openedAccordion = _.find(sbcpDocRefLs.value, (v) => v.expanded);

      if (!util.isNull(openedAccordion) && !util.isEmpty(openedAccordion)) {
        validSbcpDocRefLs = false;

        docCnf(openedAccordion.idx, openedAccordion.vo.ctnsKdCd);
      }

      if (!validSbcpDocRefLs) return false;

      _.each(sbcpDocRefLs.value, (v) => {
        if (!v.sgnInpCompYn) {
          window.scrollBy({
            top: v.$el.getBoundingClientRect().top - 30,
            behavior: "smooth",
          });
          masterButton.label = "서류확인";
          v.docCnf();

          validSbcpDocRefLs = false;
          return false;
        }
      });

      if (!validSbcpDocRefLs) return false;

      if (!state.isCnfSbcpDocDwld) {
        sbcpDocDwld();
        return false;
      }

      if (!state.isInsClusDwld) {
        insClusDwld();
        return false;
      }

      router.push({ name: "fingerPrintAth" });
    };

    //출력물 초기화
    function retrieveMblElcSgnWrdAndOpmtIntz() {
      // var param = {};
      // param.prctrNo = $scope.prctrNo;
      //출력물 전체 조회
      let transactions = [];

      transactions.push(axios.json("/retrieveElcSgnSndInf.do", {}));
      transactions.push(
        axios.json("/retrieveMblElcSgnWrd.do", { divCd: "01" })
      );

      axios
        .all(transactions)
        .then((results) => {
          if (results[0].data && results[1].data) {
            load();
            let opmtLs = results[0].data.body;
            overWriteList = results[1].data.body;

            // opmtLs = _.filter(opmtLs, function(info) {
            //   return info.ctnsKdCd != '116314'
            // })

            _.each(opmtLs, function (value, idx) {
              if (value.ctnsKdCd == "116314") {
                value.idx = -1;
                value.atcFileCtnsCdNm = "영업담당자 확인서";
              } else if (value.ctnsKdCd == "119467") {
                value.atcFileCtnsCdNm = "청약서";
              } else value.idx = idx;
            });

            state.opmtLst = _.chain(opmtLs)
              .groupBy((data) => {
                if (
                  data.ctnsKdCd == "120255" ||
                  data.ctnsKdCd == "000352" ||
                  data.ctnsKdCd == "100289" ||
                  data.ctnsKdCd == "118115" ||
                  data.ctnsKdCd == "114830" ||
                  data.ctnsKdCd == "000542" ||
                  data.ctnsKdCd == "000518" ||
                  data.ctnsKdCd == "100911" ||
                  data.ctnsKdCd == "000504" ||
                  data.ctnsKdCd == "000364" ||
                  data.ctnsKdCd == "113116" 
                ) {
                  return "000352";
                } else if (
                  data.ctnsKdCd == "100304" ||
                  data.ctnsKdCd == "119467" ||
                  data.ctnsKdCd == "113356" ||
                  data.ctnsKdCd == "000512" ||
                  data.ctnsKdCd == "119570" ||
                  data.ctnsKdCd == "119694"
                ) {
                  return "100304";
                } else {
                  return data.ctnsKdCd;
                }
              })
              .map(function (v, i) {
                let { isOverWrite, overWriteData } = parseOverWriteData(i);
                return {
                  index: _.get(_.find(v, "idx"), "idx") ?? 0,
                  ctnsKdCdNm: _.get(
                    _.find(v, "atcFileCtnsCdNm"),
                    "atcFileCtnsCdNm"
                  ),
                  ctnsKdCd: i,
                  data: v,
                  isOverWrite: isOverWrite,
                  overWriteData: overWriteData,
                };
              })
              .orderBy(["index"])
              .value();
          }
        })
        .catch((e) => {
          dialog
            .alert("출력물 생성이 실패하였습니다. 취급자에게 문의바랍니다.")
            .then(function () {
              location.go("/mblElcSgn/mblElcSgn.do", "/01");
              router.push({ name: "cellAth" });
              return false;
            });
        });
    }

    function parseOverWriteData(ctnsKdCd) {
      let isOverWrite = true;
      let overWriteData = [];

      if (overWriteData.length < 1) {
        isOverWrite = false;
      } else if (_.every(overWriteData, (d) => d.indiYn == "2")) {
        overWriteData = [];
        isOverWrite = false;
      }

      return { isOverWrite, overWriteData };
    }

    const pmmiMedInsGuidPopup = () => {
      dialog.alert(
        "설명을 듣지 못한 경우, 계약진행이 불가능합니다. 반드시 비교설명을 듣고 모바일 전자서명을 진행하시기 바랍니다."
      );
    };

    const getLabelProc = () => {
      let allSgnSucceed = true;
      let openedAccordion = _.find(sbcpDocRefLs.value, (v) => v.expanded);

      if (!util.isNull(openedAccordion) && !util.isEmpty(openedAccordion)) {
        allSgnSucceed = false;
        masterButton.label = "서류확인";
      }

      if (!allSgnSucceed) return false;

      _.each(sbcpDocRefLs.value, (v) => {
        if (!v.sgnInpCompYn) {
          masterButton.label = v.$props.vo.ctnsKdCdNm;
          allSgnSucceed = false;
          return false;
        }
      });

      if (allSgnSucceed) {
        if (!state.isCnfSbcpDocDwld) {
          masterButton.label = "청약서부본 다운로드";
        } else if (!state.isInsClusDwld) {
          masterButton.label = "약관 다운로드";
        } else {
          masterButton.label = "지문인증으로 이동";
        }
      }

      return;
    };

    const allKeyPadFinished = () => {
      masterButton.label = "서류확인";
    };

    function retrieveMblClus() {
      var param = {
        prctrNo: sessionUserInfo.prctrNo,
        bizSysCd: "CTL",
      };
      axios.json("/mobGuid/retrieveMblClus.do", param).then(function (result) {
        if (!_.isEmpty(result) && !_.isEmpty(result.data.body.pdfFilePth)) {
          var idx = result.data.body.pdfFilePth.lastIndexOf("/");
          var path = result.data.body.pdfFilePth.substring(0, idx + 1);
          var name = result.data.body.pdfFilePth.substring(idx + 1);

          variables.insClusDwldUrl =
            "/download.do?addFilePath=" + path + "&addFileNm=" + name;
        } else if (!_.isEmpty(result.data.body.hmpgFilePth)) {
          var fileName = param.prctrNo;

          var urlParam = {
            clusUrl: result.data.body.hmpgFilePth,
            fileName: state.currDate + "_" + fileName,
          };

          axios
            .json("/mobGuid/getURLToFile.do", urlParam)
            .then(function (result) {
              var pdfPath = result.data.pdfPath;
              var fileName = result.data.pdfName;

              variables.insClusDwldUrl =
                "/download.do?addFilePath=" +
                pdfPath +
                "&addFileNm=" +
                fileName;
            });
        } else {
          // dialog.alert("오류가 발생하였습니다. (PDF 정보를 찾을 수 없음)");
        }
      });
    }

    const sbcpDocDwld = () => {
      if (checkList()) {
        let agrInf = makeAgrInfData();

        store.commit("elcSgnInf/changeAgrInf", agrInf);

        let opmtParam = _.cloneDeep(sessionUserInfo);
        opmtParam = _.merge(opmtParam, store.state.elcSgnInf.acntInf);
        opmtParam = _.merge(opmtParam, store.state.elcSgnInf.cfntInf);
        opmtParam.currentDate = util.formatDate(new Date(), "yyyymmdd");
        opmtParam.agrInf = agrInf;

        let ctrBasInfCoVo = sessionUserInfo.ctrBasInfCoVo[0];

        opmtParam.sbcpDt = ctrBasInfCoVo.sbcpDt;
        opmtParam.cusNm = ctrBasInfCoVo.polhdNm;

        if (ctrBasInfCoVo.agplrCd == "") {
          opmtParam.trtpeOrgNm = ctrBasInfCoVo.trtpeOrgNm;
        } else {
          opmtParam.trtpeOrgNm = ctrBasInfCoVo.agplrNm;
        }

        opmtParam.opmtCtnsCd = "100738";
        opmtParam.athNo = sessionUserInfo.smsAthNo;
        opmtParam.dataId = sessionUserInfo.mblPrtKey;

        let inspeTrgCoVo = _.filter(
          store.state.elcSgnInf.elcSgnTrgCoVo,
          (data) => data.ptyRlCd.indexOf("02") >= 0
        )[0];

        //예금주 당사자 존재여부 확인
        if (inspeTrgCoVo.ptyRlCd.indexOf("71") >= 0) {
          opmtParam.dporElcSgnYn = "Y";
        } else {
          opmtParam.dporElcSgnYn = "N";
        }

        state.makeSbcpDoc = true;

        // 발행자정보조회
        var pblerParam = {
          prctrNo: sessionUserInfo.prctrNo,
          orgId: sessionUserInfo.orgId,
          orgCd: sessionUserInfo.orgCd,
        };

        axios.json("/getOpmtInq.do", pblerParam).then(function (result) {
          opmtParam.pblerNm = result.data.pblerNm;

          axios
            .json("/inspe/createDpcpOpmt.do", opmtParam)
            .then(function (result) {
              store.commit(
                "elcSgnInf/changeDocumentHash",
                result.data.encryValue
              );

              state.makeSbcpDoc = false;

              let param = {};
              param.prctrNo = sessionUserInfo.prctrNo;
              param.bizSysCd = "CTL";
              param.mngTrgCtnsKdCd = "119657";
              param.sndCtnsKdCd = "120445";
              param.enrlChnCd = "40";
              param.dataDivCd = "00014";

              if (isIOS) {
                param.ctnsCnfDivCd = "01";
              } else {
                param.ctnsCnfDivCd = "02";
              }
              util.saveLog("004", "청약서부본다운로드"); // 004 : 다운로드
              axios
                .json("/registPrctrCtnsCnfHis.do", param)
                .then(function (result) {
                  let dwldUrl =
                    "/download.do?" +
                    "addFilePath=/attach/sea/backup/" +
                    state.currDate +
                    "/" +
                    sessionUserInfo.prctrNo +
                    "/" +
                    "&addFileNm=" +
                    sessionUserInfo.prctrNo +
                    "_inspe.pdf";
                  if (!state.isInsClusDwld) {
                    masterButton.label = "약관 다운로드";
                  } else {
                    masterButton.label = "지문인증으로 이동";
                  }
                  downloadFrame.value.src = dwldUrl;
                  state.isCnfSbcpDocDwld = true;
                });
            });
        });
      }
    };

    const insClusDwld = () => {
      if (checkList()) {
        let param = {};
        param.prctrNo = sessionUserInfo.prctrNo;
        param.bizSysCd = "CTL";
        param.mngTrgCtnsKdCd = "119614";
        param.sndCtnsKdCd = "120445";
        param.enrlChnCd = "40";
        param.dataDivCd = "00014";

        if (isIOS) {
          param.ctnsCnfDivCd = "01";
        } else {
          param.ctnsCnfDivCd = "02";
        }
        util.saveLog("004", "약관다운로드"); // 004 : 다운로드
        axios.json("/registPrctrCtnsCnfHis.do", param).then(function (result) {
          if (!state.isCnfSbcpDocDwld) {
            masterButton.label = "청약서부본 다운로드";
          } else {
            masterButton.label = "지문인증으로 이동";
          }

          downloadFrame.value.src = variables.insClusDwldUrl;
          state.isInsClusDwld = true;
        });
      }
    };

    function makeAgrInfData() {
      let param = {};
      param.pdIntAgrYn = pdIntAgr.allPdIntAgrYn;
      param.ctrCcluAgrYn = ctrCcluAgr.allCtrCcluAgrYn;

      if (param.pdIntAgrYn == "1") {
        param.indvInfUseAgrYn = pdIntAgr.indvInfUseAgrYn;
        param.indvInfInqAgrYn = pdIntAgr.indvInfInqAgrYn;
        param.advtLnmInfRciAgrYn = pdIntAgr.advtLnmInfRciAgrYn;

        if (state.pidfPdYn) {
          if (state.inspeCnt >= 1) {
            param.inspeIndvInfUseAgrYn = pdIntAgr.indvInfUseAgrYn;
            param.inspeIndvInfInqAgrYn = pdIntAgr.indvInfInqAgrYn;
            param.inspeAdvtLnmInfRciAgrYn = pdIntAgr.advtLnmInfRciAgrYn;
            param.inspeCusNo = variables.cusNoList[0];

            try {
              param.inspeNm = variables.polhdRelLst[0].cusNm;
            } catch (Ex) {
              param.inspeNm = "";
            }
          }

          if (state.inspeCnt >= 2) {
            param.inspe1pHmnInfUseAgrYn = pdIntAgr.indvInfUseAgrYn;
            param.inspe1pHmnInfInqAgrYn = pdIntAgr.indvInfInqAgrYn;
            param.inspe1AdvtLnmInfRciAgrYn = pdIntAgr.advtLnmInfRciAgrYn;
            param.inspeCusNo1 = variables.cusNoList[1];
            try {
              param.inspeNm1 = variables.polhdRelLst[1].cusNm;
            } catch (Ex) {
              param.inspeNm1 = "";
            }
          }
          if (state.inspeCnt >= 3) {
            param.inspe2pHmnInfUseAgrYn = pdIntAgr.indvInfUseAgrYn;
            param.inspe2pHmnInfInqAgrYn = pdIntAgr.indvInfInqAgrYn;
            param.inspe2AdvtLnmInfRciAgrYn = pdIntAgr.advtLnmInfRciAgrYn;
            param.inspeCusNo2 = variables.cusNoList[2];
            try {
              param.inspeNm2 = variables.polhdRelLst[2].cusNm;
            } catch (Ex) {
              param.inspeNm2 = "";
            }
          }
          if (state.inspeCnt >= 4) {
            param.inspe3phmninfuseagryn = pdIntAgr.indvInfUseAgrYn;
            param.inspe3phmninfinqagryn = pdIntAgr.indvInfInqAgrYn;
            param.inspe3AdvtLnmInfRciAgrYn = pdIntAgr.advtLnmInfRciAgrYn;
            param.inspeCusNo3 = variables.cusNoList[3];
            try {
              param.inspeNm3 = variables.polhdRelLst[3].cusNm;
            } catch (Ex) {
              param.inspeNm3 = "";
            }
          }
          if (state.inspeCnt >= 5) {
            param.inspe4phmninfuseagryn = pdIntAgr.indvInfUseAgrYn;
            param.inspe4phmninfinqagryn = pdIntAgr.indvInfInqAgrYn;
            param.inspe4AdvtLnmInfRciAgrYn = pdIntAgr.advtLnmInfRciAgrYn;
            param.inspeCusNo4 = variables.cusNoList[4];
          }
        }
      } else {
        param.indvInfUseAgrYn = "2";
        param.indvInfInqAgrYn = "2";
        param.advtLnmInfRciAgrYn = "2";
        if (state.pidfPdYn) {
          if (state.inspeCnt >= 1) {
            param.inspeIndvInfUseAgrYn = pdIntAgr.indvInfUseAgrYn;
            param.inspeIndvInfInqAgrYn = pdIntAgr.indvInfInqAgrYn;
            param.inspeAdvtLnmInfRciAgrYn = pdIntAgr.advtLnmInfRciAgrYn;
            param.inspeCusNo = variables.cusNoList[0];
            try {
              param.inspeNm = variables.polhdRelLst[0].cusNm;
            } catch (Ex) {
              param.inspeNm = "";
            }
          }
          if (state.inspeCnt >= 2) {
            param.inspe1pHmnInfUseAgrYn = pdIntAgr.indvInfUseAgrYn;
            param.inspe1pHmnInfInqAgrYn = pdIntAgr.indvInfInqAgrYn;
            param.inspe1AdvtLnmInfRciAgrYn = pdIntAgr.advtLnmInfRciAgrYn;
            param.inspeCusNo1 = variables.cusNoList[1];
            try {
              param.inspeNm1 = variables.polhdRelLst[1].cusNm;
            } catch (Ex) {
              param.inspeNm1 = "";
            }
          }
          if (state.inspeCnt >= 3) {
            param.inspe2pHmnInfUseAgrYn = pdIntAgr.indvInfUseAgrYn;
            param.inspe2pHmnInfInqAgrYn = pdIntAgr.indvInfInqAgrYn;
            param.inspe2AdvtLnmInfRciAgrYn = pdIntAgr.advtLnmInfRciAgrYn;
            param.inspeCusNo2 = variables.cusNoList[2];
            try {
              param.inspeNm2 = variables.polhdRelLst[2].cusNm;
            } catch (Ex) {
              param.inspeNm2 = "";
            }
          }
          if (state.inspeCnt >= 4) {
            param.inspe3phmninfuseagryn = pdIntAgr.indvInfUseAgrYn;
            param.inspe3phmninfinqagryn = pdIntAgr.indvInfInqAgrYn;
            param.inspe3AdvtLnmInfRciAgrYn = pdIntAgr.advtLnmInfRciAgrYn;
            param.inspeCusNo3 = variables.cusNoList[3];
            try {
              param.inspeNm3 = variables.polhdRelLst[3].cusNm;
            } catch (Ex) {
              param.inspeNm3 = "";
            }
          }
          if (state.inspeCnt >= 5) {
            param.inspe4phmninfuseagryn = pdIntAgr.indvInfUseAgrYn;
            param.inspe4phmninfinqagryn = pdIntAgr.indvInfInqAgrYn;
            param.inspe4AdvtLnmInfRciAgrYn = pdIntAgr.advtLnmInfRciAgrYn;
            param.inspeCusNo4 = variables.cusNoList[4].cusNm;
          }
        }
      }

      param.bioAthAgrYn = "1";

      return param;
    }

    function checkList() {
      let validSbcpDocRefLs = true;

      _.each(sbcpDocRefLs.value, (v) => {
        if (!v.sgnInpCompYn) {
          dialog
            .alert(v.$props.vo.ctnsKdCdNm + " 서류를 확인하여 주세요.")
            .then(() => {
              window.scrollBy({
                top: v.$el.getBoundingClientRect().top - 30,
                behavior: "smooth",
              });
            });
          validSbcpDocRefLs = false;
          return false;
        }
      });

      if (!validSbcpDocRefLs) return false;

      return true;
    }

    return {
      state,
      pmmiMedInsAgr,
      fireCmpsRpsbIns,
      th3peInsAgr,
      pdIntAgr,
      ctrCcluAgr,
      bioCcluAgr,
      sbcpDocRefLs,
      addInpRefLs,
      docCnf,
      load,
      sessionUserInfo,
      pmmiMedInsGuidPopup,
      allSetAgr,
      setAgr,
      goPrevPage,
      goNextPage,
      openDoc,
      docCreated,
      getLabelProc,
      allKeyPadFinished,
      masterButton,
      sbcpDocDwld,
      insClusDwld,
      downloadFrame,
    };
  },
};
</script>
